import { LitElement, html } from 'lit';

import { navigate } from '../../lib/router/index.js';
import { api } from '../api/index.js';
import { formStyles } from '../../styles/shared/forms.js';
import { pageStyles } from '../../styles/shared/page.js';
import { newCustomerPageStyles } from '../../styles/pages/new-customer-page.js';

/** A new customer: once created, its page, where its first owner is invited. */
class NewCustomerPage extends LitElement {
  static properties = {
    busy: { state: true },
    actionError: { state: true },
  };

  static styles = [
    pageStyles,
    formStyles,
    newCustomerPageStyles,
  ];

  constructor() {
    super();
    this.busy = false;
    this.actionError = null;
  }

  async create(event) {
    event.preventDefault();
    this.busy = true;
    this.actionError = null;
    try {
      const customer = await api.createCustomer(event.target.elements.name.value.trim());
      navigate(`/customers/${customer.id}`);
    } catch (error) {
      this.actionError = error.message;
      this.busy = false;
    }
  }

  render() {
    return html`
      <nav class="crumbs" aria-label="Breadcrumb"><a href="/customers">Customers</a> / new</nav>
      <header class="page-head">
        <div>
          <h1>New customer</h1>
        </div>
      </header>
      ${this.actionError ? html`<div class="notice" data-tone="danger" role="alert"><strong>The customer was not created</strong>${this.actionError}</div>` : null}
      <form @submit=${(event) => this.create(event)}>
        <div class="field">
          <label for="name">Name</label>
          <span class="help">Next, on its page: invite its first owner, and create its workspaces or assign existing ones.</span>
          <input id="name" name="name" type="text" required maxlength="200" placeholder="e.g. Studio Rossi" />
        </div>
        <div class="buttons">
          <button class="primary" ?disabled=${this.busy}>Create customer</button>
          <a class="button" href="/customers">Cancel</a>
        </div>
      </form>
    `;
  }
}

customElements.define('plane-new-customer-page', NewCustomerPage);
